<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        {{ this.$route.meta.title }}
        <div class="card-header-actions">
          <b-button variant="primary mr-1" @click="posting()"><i class="fa fa-upload"></i> Posting</b-button>
          <!-- <b-button variant="primary mr-1" @click="postingBank()"><i class="fa fa-usd"></i> Posting Bank</b-button> -->
          <b-button variant="primary mr-1" @click="exportxls()"><i class="fa fa-file-excel-o"></i> Export</b-button>
        </div>
      </div>
      <b-row>
        <b-col>
          <b-input-group>
            <b-input-group-prepend>
              <label>Periode Trx.</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.tgl1" type="date"></b-form-input>
            <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
            <b-form-input v-model="tblData.tgl2" type="date"></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Partner Transaction</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.partnerTransactionId" placeholder=""></b-form-input>
          </b-input-group>
        </b-col>
        <b-col>
          <b-input-group>
            <b-input-group-prepend>
              <label>Loan Id</label>
            </b-input-group-prepend>
          </b-input-group>
          <b-input-group>
              <b-input-group-prepend>
                <label>Project</label>
              </b-input-group-prepend>
              <b-form-select v-model="tblData.pjxkey" :plain="true" :options="projectsFilt"></b-form-select>  
              <b-button class="btn btn-success ml-1" @click="refresh()">
                <i class="fa fa-refresh"></i> Apply
              </b-button>
              <b-button class="btn btn-secondary ml-1" @click="clearFilter()">
                <i class="fa fa-eraser"></i>Clear
              </b-button>
            </b-input-group>
        </b-col>
      </b-row>
      <b-table class="mb-0" ref="table" outlined responsive striped hover small style="font-size:smaller;" :items="data"
        :fields="tblFields" :current-page="tblData.page" :per-page="tblData.limit" :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc" :key="tblData.limit" :busy="isBusy" @row-clicked="rowClicked"
        @row-dblclicked="rowDblClicked" show-empty>
        <template v-slot:cell(index)="data">{{ ((tblData.page - 1) * tblData.limit) + (data.index + 1) }}</template>
        <template v-slot:cell(disbursed_date)="data">{{ data.item.disbursed_date | moment("YYYY MMM DD") }}</template>
        <template v-slot:cell(count_trx)="data">{{ data.item.count_trx | numFormat('0,0')
        }}</template>
        <template v-slot:cell(loan_amount_sum)="data">{{ data.item.loan_amount_sum | numFormat('0,0.00') }}</template>

        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>
        <template v-slot:cell(empty)="data">
          <h4>{{ data.emptyText }}</h4>
        </template>
        <template v-slot:cell(emptyfiltered)="data">
          <h4>{{ data.emptyFilteredText }}</h4>
        </template>

        <template v-slot:custom-foot>
          <b-tr>
            <b-th colspan="2" class="text-center"><span class="">TOTAL</span></b-th>
            <b-th class="text-right"><span class="text-right">{{ tblData.count_trx | numFormat('0,0') }}</span></b-th>
            <b-th class="text-right"><span class="text-right">{{ tblData.loan_amount | numFormat('0,0.00') }}</span>
            </b-th>
          </b-tr>
        </template>


      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{ (tblData.page - 1) * tblData.limit + 1 }}
            to
            <span v-if="((tblData.page * tblData.limit) > tblData.total)">{{ tblData.total }}</span>
            <span v-else>{{ tblData.page * tblData.limit }}</span>
            of {{ tblData.total | numFormat }} entries
          </div>
        </b-col>
        <b-col cols="4">
          <b-form-group label-cols="3" label style="margin-top:0 !important;">
            <b-input-group>
              <b-input-group-prepend class="mr-2">
                <label>Limit per page</label>
              </b-input-group-prepend>
              <div class="d-flex">
                <b-form-select :options="[10, 15, 20, 25]" :plain="true" v-model="tblData.limit" size="sm"
                  style="width:80px" />
              </div>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-pagination align="right" :total-rows="tblData.total" :per-page="tblData.limit" v-model="tblData.page">
          </b-pagination>
        </b-col>
      </b-row>
    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4"></loading>
  </div>
</template>
  
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";
import dropdown from "../../data/dropdown";
import toastr from "mini-toastr";
import crud from "../../apis/crud";
import disbursement from "../../apis/disbursement";

toastr.init();
export default {
  components: { Loading },
  data() {
    return {
      showFilter: true,
      isBusy: false,
      isLoading: false,
      projectsFilt:[{
        value:'',text:'-- ALL --'
      }],
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: "disbursed_date",
        sortDesc: true,
        loan_amount: 0,
        tgl1: moment().startOf('M').format('YYYY-MM-DD'), tgl2: moment().format('YYYY-MM-DD'),
        partnerTransactionId: '', loan_id: '',pjxkey:''
      },
      dataList: {
        debiturStatus: dropdown.debiturStatus
      },
    };
  },
  computed: {
    tblFields() {
      const fields = [
        {
          key: "index",
          label: "No.",
          thClass: "text-center",
          sortable: true
        },
        {
          key: "disbursed_date",
          label: "Disbursed Date",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true
        },
        {
          key: "count_trx",
          label: "Count Transaction",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true
        },
        {
          key: "loan_amount_sum",
          label: "Amount",
          thClass: "text-center",
          tdClass: "text-right",
          tdStyle: "margin-right:10px",
          sortable: true
        },
        {
          key: "nomor",
          label: "Trx. Bank No.",
          thClass: "text-center",
          tdClass: "text-left",
          tdStyle: "margin-right:10px",
          sortable: true
        },
        {
          key: "isPosted",
          label: "Posting To Accounting",
          thClass: "text-center",
          tdClass: "text-left",
          tdStyle: "margin-right:10px",
          sortable: true
        },
        {
          key: "pjxconcat",
          label: "Project",
          thClass: "text-center",
          tdClass: "text-left",
          tdStyle: "margin-right:10px",
          sortable: true
        },
      ];
      return fields;
    },
  },
  async created() {
    const [projects] = await Promise.all([crud.list({
      tablename: 'project',
      page: 1,
      limit: 10000,
      total: 0,
      sortBy: 'pjxname',
      sortDesc: false,
    })]);

    projects.forEach(tp => {
      this.projectsFilt.push({ value: tp.pjxkey, text: tp.pjxname })
    });
  },
  methods: {
    postingBank() {
      try {
        if (!this.model) {
          toastr.warn('Please select a row that want to be POSTING!');
          return;
        }
        this.$router.push({ name: 'transaction.payment', params: { data: this.model } })
      } catch (error) {

      }
    },
    async posting() {
      try {
        this.isLoading = true;
        if (!this.model) {
          this.isLoading = false;
          toastr.warn('Please select a row that want to be POSTING!');
          return;
        }
        await disbursement.posting(this.model);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    rowDblClicked(record, index) {
      const route = this.$router.resolve({
        name: "transaction.disbursement", query: {
          tgl1: moment(record.disbursed_date).format('YYYY-MM-DD'),
          tgl2: moment(record.disbursed_date).format('YYYY-MM-DD')
        }
      });
      window.open(route.href, '_blank');
    },
    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
        delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant = 'info';
      this.$forceUpdate();
      // }
    },
    async data() {
      try {
        this.isBusy = true;
        const filter = this.$store.state.filter;
        let filtered = false;
        for (var key in filter.debiturList) {
          this.tblData[key] = filter.debiturList[key];
          filtered = true;
        }
        if (filtered === true) {
          this.showFilter = filtered;
          delete filter.debiturList;
          this.$store.commit("filter", filter);
        }
        this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
        if (this.tblData.tgl1 || this.tblData.tgl2) {
          if ((this.tblData.tgl2 || '') == '') {
            this.tblData.tgl2 = this.tblData.tgl1;
          }
        }
        this.tblData.loan_amount = 0;
        const list = await disbursement.report(this.tblData);
        this.isBusy = false;
        return list;
      } catch (error) {
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    async exportxls() {
      try {
        this.isLoading = true;
        await disbursement.exportreportxls(this.tblData);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    async refresh() {
      try {
        this.$refs.table.refresh();
      } catch (error) {
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    clearFilter() {
      this.tblData.custinfo = "";
      this.tblData.nomoridentitas = "";
      this.tblData.alamatktp = "";
      this.tblData.npwp = "";
      this.tblData.collector_name = "";
      this.refresh();
    },

    close() {
      router.push({ name: "paylater.home" });
    }
  }
};
</script>